import type { ApiRentalBookingQuote } from 'src/types/rental';

import { useQuery } from '@tanstack/react-query';

import axios from 'src/utils/axios';

import { QueryKeys } from './QueryKeys';
import { LIVE_STALE_TIME } from './staleness';

/**
 * What the picked dates cost (GET /buyer/rentals/:id/quote). The server prices the booking by the
 * duration band it falls into and returns every line in base units, computed the way the escrow
 * contract computes them — so the booking screen shows money instead of deriving it (spec §2).
 *
 * Disabled until both dates are picked; a rejected quote (dates outside the listing's min/max) is
 * surfaced as an error rather than retried.
 */
export function useRentalBookingQuote(id: string, startDate: string, endDate: string) {
  return useQuery({
    queryKey: QueryKeys.rentalBookingQuote(id, startDate, endDate),
    queryFn: async (): Promise<ApiRentalBookingQuote> => {
      const response = await axios.get<ApiRentalBookingQuote>(`/buyer/rentals/${id}/quote`, {
        params: { startDate, endDate },
      });
      return response.data;
    },
    enabled: Boolean(id && startDate && endDate),
    retry: false,
    staleTime: LIVE_STALE_TIME,
  });
}
